import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICategoryCarPermission } from '../../api/menu/MenuApi';

const initialCategoryCarSlice: ICategoryCarPermission[] = []

const categoryCarSlice = createSlice({
  name: 'categoryCarSlice',
  initialState: initialCategoryCarSlice,
  reducers: {
    setCategoryCar: (state, action: PayloadAction<ICategoryCarPermission[]>) => action.payload,
    clearCategoryCar: (state) => initialCategoryCarSlice
  }
})

export const selectorCategoryCar = (state: { categoryCarSlice: ICategoryCarPermission[] }) => state.categoryCarSlice;
export const selectorCategoryCarIds = createSelector(
  [selectorCategoryCar],
  (categoryCars) => categoryCars.map(item => item.categoryCarId)
)
export const { setCategoryCar, clearCategoryCar } = categoryCarSlice.actions;
export default categoryCarSlice.reducer;
